import Reveal from "./Reveal";

const CALLOUTS = [
  { className: "c1", label: "Lab & Radiology linked" },
  { className: "c2", label: "Dietitian notified instantly" },
  { className: "c3", label: "Physiotherapy synced" },
  { className: "c4", label: "BMI & vitals auto-calculated" },
  { className: "c5", label: "Fully customisable case sheet" },
];

export default function ProductPreview() {
  return (
    <section className="preview-section" aria-labelledby="preview-heading">
      <div className="wrap">
        <span className="kicker">See it in action</span>
        <h2 className="section-title" id="preview-heading">
          Fully customisable case sheet — <b>every department watching</b>
        </h2>
        <p className="section-lede">
          Shape sections, order, and specialty panels to how your clinic works. Open a patient&apos;s
          chart and the whole team is already connected — vitals feed the dietitian, physio notes sync,
          and lab and radiology sit one click away.
        </p>

        <Reveal className="preview-shell">
          <div className="preview-frame">
            <div className="preview-chrome">
              <span className="dot" aria-hidden="true" />
              <span className="dot" aria-hidden="true" />
              <span className="dot" aria-hidden="true" />
              <span className="url">app.deepaarogya.com/case-sheet</span>
            </div>
            <img
              src={`${process.env.PUBLIC_URL}/images/case-sheet-preview.png`}
              alt="Deepaarogya AI fully customisable case sheet for Ms Sree Teja G — vitals, diagnosis, and connected Dietitian, Physiotherapy, and Radiology panels"
              loading="lazy"
            />
          </div>

          <div className="preview-callouts" aria-hidden="true">
            {CALLOUTS.map((c) => (
              <span className={`callout ${c.className}`} key={c.label}>
                <span className="dot" aria-hidden="true" />
                {c.label}
              </span>
            ))}
          </div>
        </Reveal>

        <div className="preview-caption">
          <span className="kicker">No re-entry. No missed handoffs.</span>
          <p>
            Every tab you see — Dx, Vitals, Physio, Meds, Notes — writes to the same patient record
            every other department reads from. Customise the layout once; your whole clinic follows it.
          </p>
        </div>
      </div>
    </section>
  );
}
